import React from 'react';
import type { CampaignGenerationJob } from '../types';
import ReactTable from 'react-table';
import { Tag } from 'antd';

type Props = {
  campaignGenerationJob: CampaignGenerationJob,
};

const columnsDefs = [
  {
    id: 'key',
    Header: 'Argument Name',
    accessor: row => <b>{row.key}</b>,
    maxWidth: 200,
  },
  {
    id: 'value',
    Header: 'Argument Value',
    style: { paddingBottom: 0 },
    accessor: row => {
      if (Array.isArray(row.value)) {
        return (
          <div className="flex flex-wrap">
            {row.value.map((v, i) => (
              <Tag className="mr-2 mb-2" key={i}>
                {v}
              </Tag>
            ))}
          </div>
        );
      }
      return <Tag className="mb-2">{row.value}</Tag>;
    },
  },
];

export default function CampaignGenerationJobArgumentsInfo(props: Props) {
  const { campaignGenerationJob } = props;
  const { arguments: args } = campaignGenerationJob;
  return (
    <ReactTable
      columns={columnsDefs}
      data={Object.entries(args).map(([key, value]) => ({ key, value }))}
      minRows={0}
      pageSize={Object.keys(args).length}
      showPagination={false}
    />
  );
}
